import { Reducer } from 'react';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { HostedVideoActions } from '..';
import { saveVideoPasswordAsync } from '../actions';
import { getUpdatedList } from '../helpers';

import { initialHostedVideoState } from './index';

const saveVideoPasswordReducer: Reducer<
  typeof initialHostedVideoState,
  HostedVideoActions
> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(saveVideoPasswordAsync.request): {
      const password = action.payload;

      return {
        ...state,
        saveVideoPassword: {
          ...state.saveVideoPassword,
          isPending: true,
          isError: false
        },
        videoData: {
          ...state.videoData!,
          password
        }
      };
    }
    case getType(saveVideoPasswordAsync.success): {
      return {
        ...state,
        list: getUpdatedList(state.list, action.payload),
        saveVideoPassword: {
          ...state.saveVideoPassword,
          isPending: false,
          isError: false,
          error: null
        },
        videoData: {
          ...state.videoData!,
          savedData: {
            ...state.videoData?.savedData!,
            password: state.videoData?.password!
          }
        }
      };
    }
    case getType(saveVideoPasswordAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        saveVideoPassword: {
          ...state.saveVideoPassword,
          error,
          isPending: false,
          isError: true
        }
      };
    }
    default:
      return state;
  }
};

export default saveVideoPasswordReducer;
